import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
	BasicSelect
} from 'vue-search-select'

export default {
	name: 'group-mapping',
	components: {
		BasicSelect,
		VueElementLoading
	},
	props: [],
	data() {
		return {
			cityList: [],
			cityData:[],
			groupDetails:[],
			input:{},
			checkMapModel:false,

			isLoadingSearch:false,
			cityDataItem: {
				id: '',
				text: ''
			},
			city:'',
			hubzoneLoading: '',
			hubLoading:'',
			createdBy:'',
			PTLDetails:[],
			invalidTokenModal: false,
      invalidtokenmsg: ''
		}
	},
	computed: {

	},
	filters: {
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdBy = userdetail[0].email;
		this.getAllCities();

	},
	methods: {
		getAllCities() {
			this.hubzoneLoading = 'Loading Cities...'
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				// hubName: this.cityDataItem.id,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'allcity/get',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubzoneLoading = ''
					let cityData = result.data.ResponseData;
					for (i = 0; i < cityData.length; i++) {
						this.cityList.push({
							id: cityData[i].cityid,
							text:cityData[i].cityname
						})
					}
					this.showGroupDetails();
				}, error => {
					console.error(error)
				})
		},
		selectCity(cityDataItem) {
			this.cityDataItem = cityDataItem
			this.city = this.cityDataItem.id
		},
		onSubmit: function() {
			var self = this
			this.$validator.validateAll().then((result) => {
					this.showGroupDetails()
			}).catch(() => {
				console.log('errors exist')
			});
		},
		showGroupDetails() {
			this.input={
			}
		axios({
				method: 'GET',
				url: apiUrl.api_url_hubops + 'getNotMappedGroupList?cityId='+this.city,
				data:this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
					'requestfrom': "WEB",
					'token': this.token
				}
			})
			.then(result => {
				this.groupDetails=[]
				if (result.data.ResultCode == 100) {
					this.invalidTokenModal = false
					this.groupDetails=result.data.ResponseData

					var hubDetails = [];
					var logData = [];
					for (var i = 0; i < this.cityList.length; i++) {
						hubDetails[this.cityList[i].value] = this.cityList[i].text;
					}

					if (result.data.ResponseData.length > 0) {
						this.cityList.forEach(function(cityData) {
						result.data.ResponseData.forEach(function(item) {
							if (item.cityid == cityData.id) {
								item["cityname"] = '';
								item["cityname"] = `${cityData.text}(${item.cityid})`;
								logData.push(item);
							}
						});
						});
					}

				}else if (result.data.ResultCode == 401) {
					this.invalidTokenModal = true
					this.invalidtokenmsg = result.data.ReturnMessage
					this.$alertify.error(result.data.ReturnMessage)
				} else {
					this.invalidTokenModal = false
					this.$alertify.error(result.data.ReturnMessage);
				}
			}, error => {
				console.error(error)
			})
	},
	openConfirmationModel(data)
	{
		this.input=data;
		this.checkMapModel=true;
	},
	closeConfirmationModel()
	{
		this.checkMapModel=false;
		$(document.body).removeClass("modal-open");
		$(".modal-backdrop").remove();
	},
		mapNewGroupToPTL(data) {
			this.input={
				groupId:this.input.groupid,
				createdBy:this.createdBy
			}
		axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'mapNewGroupToPTL',
				data:this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
					'requestfrom': "WEB",
					'token': this.token
				}
			})
			.then(result => {
				this.closeConfirmationModel();
				if (result.data.ResultCode == 100) {
					this.invalidTokenModal = false
					this.PTLDetails=result.data.ResponseData
					this.showGroupDetails();
					this.$alertify.success(result.data.ReturnMessage);
				}else if (result.data.ResultCode == 401) {
					this.invalidTokenModal = true
					this.invalidtokenmsg = result.data.ReturnMessage
					this.$alertify.error(result.data.ReturnMessage)
				} else {
					this.invalidTokenModal = false
					this.$alertify.error(result.data.ReturnMessage);
				}
			}, error => {
				console.error(error)
			})
	},
		logout(e) {
			localStorage.removeItem('permissiondata')
			localStorage.removeItem('userdetail')
			localStorage.removeItem('userToken')
			localStorage.removeItem('isLoggedIn')
			localStorage.removeItem('loginDate')
			this.$router.push('/login')
			e.preventDefault()
		},
		closeinvalidTokenModal() {
			this.invalidTokenModal = false
			this.invalidtokenmsg = ''
		},
		resetForm(){
			this.groupDetails=[]
			this.hubzoneLoading=''
			this.groupLoading=''
			this.hubLoading=''
		 	this.isLoadingSearch= false;
		 	this.city=''
		 	this.cityDataItem={
			 	value:'',
			 	text:''
		 	}
			this.PTLDetails=[]
		 	this.$validator.reset();
	 }
	}
}



// WEBPACK FOOTER //
// ./src/views/components/PTLMapping/GroupMapping/GroupMapping.js